import { Injectable } from "@angular/core";
import { Cargo } from "../interfaces/cargo";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ResponseGenerateJournalComponent } from "src/app/modules/cargo/response-generate-journal/response-generate-journal.component";
import { Dialog } from "../resources/dialog";
import { CargoGenerateService } from "../services/cargoGenerate.service";
import { ModalEnum } from "../enums/modal.enum";

@Injectable()
export class SiigoManager {

    constructor(
        public matDialog: MatDialog,
        private cargoGenerateService: CargoGenerateService
    ) {

    }

    public generateJournal(consecutives: number[]): Promise<{ cargosJournalSuccess: Cargo[], cargosJournalError: Cargo[], error: Error }> {
        return new Promise((resolve, reject) => {
            this.cargoGenerateService.generateJournal(consecutives).subscribe(
                (response) => {
                    const value = this.validateResponseGenerateJournal(response);
                    resolve(value);
                },
                (error) => {
                    const value = this.validateResponseGenerateJournal(error);
                    reject(value);
                }
            );
        });
    }

    private validateResponseGenerateJournal(response): { cargosJournalSuccess: Cargo[], cargosJournalError: Cargo[], error: Error } {
        let cargosJournalError = [];
        let cargosJournalSuccess = [];
        let error: Error = null;

        if (response && response.length) {
            cargosJournalError = response.filter((cargo) => {
                return cargo.journalError && cargo.journalError.hasError;
            });
            cargosJournalSuccess = response.filter((cargo) => {
                return !cargo.journalError || !cargo.journalError.hasError;
            });
        } else {
            error = response;
        }
        return {
            cargosJournalError,
            cargosJournalSuccess,
            error
        };
    }

    public async showResponseGenerateJournal(response: { cargosJournalSuccess: Cargo[], cargosJournalError: Cargo[], error: Error }): Promise<Cargo[]> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            ...response
        };
        dialogConfig.autoFocus = false;
        dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
        dialogConfig.width = ModalEnum.SMALL_WIDTH;
        dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
        const result = await this.matDialog.open(ResponseGenerateJournalComponent, dialogConfig).afterClosed().toPromise();
        if (result && result.cargosError) return result.cargosError;
        return null;
    }
}
